import * as React from 'react'
import {
  CareersDescriptionContainer, CareersDescriptionContent, CareersDescriptionContentItem,
  CareersDescriptionTitle, CareersDescriptionTitleText,
  CareersDescriptionWrapper, IFrameContainer, ItemParagraph, ItemText, ItemTitle
} from './CareersDescription.elements'

type CareersDescriptionItem = {
  title: string
  text: string
}

type Props = {
  title: string
  items: CareersDescriptionItem[]
}

export const CareersDescription: React.FunctionComponent<Props> = ({title, items}) => (
  <CareersDescriptionContainer>
    <CareersDescriptionWrapper>
      <CareersDescriptionTitle>
        <CareersDescriptionTitleText>
          {title}
        </CareersDescriptionTitleText>
      </CareersDescriptionTitle>
      <CareersDescriptionContent>
        {items.map((i, idx) =>
          <CareersDescriptionContentItem key={idx + i.title}>
            <ItemTitle>
              {i.title}
            </ItemTitle>
            <ItemText>
              <ItemParagraph>
                {i.text}
              </ItemParagraph>
            </ItemText>
          </CareersDescriptionContentItem>
        )}
      </CareersDescriptionContent>
    </CareersDescriptionWrapper>
  </CareersDescriptionContainer>
);
